import React from "react";
import GlobalBanner from "../GlobalBanner";
import { FaTruckFast } from "react-icons/fa6";
import { MdFastfood } from "react-icons/md";
import { Link } from "react-router-dom";

function Menu() {
  const services = [
    {
      icon: "https://cdn-icons-png.flaticon.com/128/1012/1012370.png",
      title: "Table Menu",
      link: "/table-menu",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/128/1329/1329894.png",
      title: "Party Menu",
      link: "/party-menu",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/128/16399/16399661.png",
      title: "Parcel Menu",
      link: "/parcel-menu",
    },
  ];

  return (
    <div>
      <GlobalBanner
        title="Menus"
        subtitle="Menus"
        bgImage="/images/menuimg.webp"
      />
      <div className="py-20 bg-cream">
        <div className="container mx-auto px-4">
          <div className="text-center mb-20">
            <h5 className="text-primary-dark text-lg font-semibold mb-2">
              Our Services
            </h5>
            <h1 className="font-display text-3xl md:text-5xl font-bold">
              Explore Our Services
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:px-28 gap-6">
            {services.map((service, index) => (
              <Link to={service.link} key={index}>
                <div className="relative rounded-2xl pt-4 bg-white cursor-pointer shadow-[0_0_45px_rgba(0,0,0,0.08)] hover:bg-primary transition-all duration-500 group overflow-hidden">
                  {/* Diagonal Ribbon */}
                  <div className="absolute top-4 right-[-30px] w-[120px] rotate-45 bg-black text-white text-center text-xs py-1 opacity-0 group-hover:opacity-100 transition-all duration-500">
                    View more
                  </div>

                  <div className="p-6 text-center">
                    <img
                      src={service.icon}
                      className="w-24 mx-auto mb-4 transition-all duration-500 group-hover:scale-110"
                      alt=""
                    />
                    <h5 className="text-2xl font-semibold group-hover:text-white transition duration-500">
                      {service.title}
                    </h5>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
